export class DeviceDetector {

    constructor() {
        this.html = document.documentElement;
        this.resizeTimer = null;
    }

    init() {
        // Выполняем первичную проверку без тяжелых вычислений размеров
        this.updateDeviceType();

        // Откладываем тяжелые вычисления до момента, когда DOM будет готов
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.updateMetrics());
        } else {
            this.updateMetrics();
        }

        this.initLoader();
        this.bindEvents();
    }

    updateDeviceType() {
        // Более легкий способ определить тач-устройство
        const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

        if (isTouch) {
            this.html.classList.add('touch');
            this.html.dataset.device = 'touch';
        } else {
            this.html.classList.remove('touch');
            this.html.dataset.device = 'desk';
        }
    }

    updateMetrics() {
        // Используем rAF, чтобы не блокировать основной поток
        window.requestAnimationFrame(() => {
            // Читаем только если это действительно нужно
            // PageSpeed не любит лишние dataset на корневом элементе, если они не используются в CSS
            this.html.dataset.width = window.innerWidth;
            this.html.dataset.height = window.innerHeight;

            // alert(window.innerWidth + ' -- ' + window.innerHeight);
        });
    }

    initLoader() {
        const setLoaded = () => {
            window.requestAnimationFrame(() => {
                this.html.classList.add('loaded');
                this.html.dataset.loaded = 'true';
            });
        };

        if (document.readyState === 'complete') {
            setLoaded();
        } else {
            window.addEventListener('load', setLoaded, { once: true });
        }
    }

    bindEvents() {
        // Оптимизируем ресайз через debounce
        window.addEventListener("resize", () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.updateMetrics();
            }, 250); // Обновляем данные только спустя 250мс после остановки ресайза
        }, { passive: true });

        window.addEventListener("orientationchange", () => this.updateMetrics(), { passive: true });
    }
}